export default "__VITE_ASSET__DL__3Y03__"